import { useState, useEffect } from "react";
import { createNFT, getUserCollections, uploadImage } from "../../../api/axios";
import imgg from "../../../assets/upload_img_2.svg";
import FieldError from "../../../shared/FieldError/FieldError";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Spinner from "../../../shared/Spinner/Spinner";
import styles from "./Card.module.scss";

const Card = () => {
  const formData = new FormData();
  const [loading, setLoading] = useState(false);
  const [imgLoading, setImgLoading] = useState(false);

  // user from localstorage
  const user = localStorage.getItem("user");

  // input states
  const [img, setImg] = useState("");
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [collection, setCollection] = useState("");
  const [visibility, setVisibility] = useState("");
  const [properties, setProperties] = useState("");
  const [price, setPrice] = useState("");
  const [collections, setCollections] = useState("");

  // errors
  const [imgError, setImgError] = useState("");
  const [nameError, setNameError] = useState("");
  const [descriptionError, setDescriptionError] = useState("");
  const [collectionError, setCollectionError] = useState("");
  const [visibilityError, setVisibilityError] = useState("");
  const [propertiesError, setPropertiesError] = useState("");
  const [priceError, setPriceError] = useState("");

  // fetch all user collections
  // useEffect(() => {
  //   const fetchUserCollections = async () => {
  //     const response = await getUserCollections();

  //     if (response.status === 200) {
  //       setCollections(response.data.data);
  //     } else {
  //       console.log(response);
  //     }
  //   };

  //   fetchUserCollections();
  // }, []);

  // handle image upload
  const onImageUpload = async (e) => {
    setImgLoading(true)
    formData.append("file", e.target.files[0]);
    formData.append("upload_preset", "o959yirs");

    const response = await uploadImage(formData);
    if (response.status === 200) {
      setImg(response.data.url);
      setImgLoading(true)
    } else {
      setImg("error");
      setImgLoading(true)
    }
  };

  // handle submit
  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   if (!img) {
  //     setImgError("NFT Image is required!");
  //   }
  //   if (!name) {
  //     setNameError("Name is required!");
  //   }
  //   if (!description) {
  //     setDescriptionError("Description is required!");
  //   }
  //   if (!collection) {
  //     setCollectionError("Collection is required!");
  //   }
  //   if (!visibility) {
  //     setVisibilityError("Visibility status is required!");
  //   }
  //   if (!properties) {
  //     setPropertiesError("Properties are required!");
  //   }
  //   if (!price) {
  //     setPriceError("Price are required!");
  //   }

  //   if (img && name && description && collection && properties && price) {
  //     setLoading(true);

  //     // clear errors
  //     setImgError(null);
  //     setNameError(null);
  //     setDescriptionError(null);
  //     setCollectionError(null);
  //     setVisibilityError(null);
  //     setPropertiesError(null);
  //     setPriceError(null);
      

  //     const parsed = JSON.parse(user);

  //     var propertiesArr = properties.split(/(\s+)/);
  //     const filteredProperties = propertiesArr.filter((i) => i !== " ");

  //     const payload = {
  //       userId: parsed._id,
  //       collectionId: collection,
  //       nftName: name,
  //       nftdescription: description,
  //       nftImage: img,
  //       nftProperties: filteredProperties,
  //       live: visibility,
  //       solanaPrice: price,
  //     };

  //     const response = await createNFT(payload);

  //     if (response.status === 200) {
  //       console.log(response);
  //       toast.success(response.data.message);
  //       setLoading(false);
  //     } else {
  //       console.log(response);
  //       toast.error(response.data.message);
  //       setLoading(false);
  //     }
  //   }
  // };

  return (
    <div className={styles.container}>
      <form 
      // onSubmit={handleSubmit}
      >
        {img ? (
          <div className={styles.field}>
            <img src={img} alt="preview" className={styles.placeholder} />
          </div>
        ) : (
          <div className={styles.field}>
            <label>
              Image, Audio, Video, Gif<span>*</span>
            </label>
            <div className={styles.upload}>
              <img src={imgg} alt="upload-logo" />
              <input type="file" name="uploadLogo" onChange={onImageUpload} />
              <p>Upload Here</p>
            </div>
            {imgError && <FieldError message={imgError} />}
          </div>
        )}

        <div className={styles.field}>
          <label>
            Name<span>*</span>
          </label>
          <input
            type="text"
            placeholder="E.g My NFT"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          {/* {nameError && <FieldError message={nameError} />} */}
        </div>
        <div className={styles.field}>
          <label>
            Description<span>*</span>
          </label>
          <textarea
            name="description"
            cols="30"
            rows="10"
            placeholder="Write few lines about your NFT..."
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          ></textarea>
          {/* {descriptionError && <FieldError message={descriptionError} />} */}
        </div>
        <div className={styles.field}>
          <label>
            Price<span>*</span>
          </label>
          <input
            type="number"
            placeholder="E.g 2.5"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
          />
          {/* {priceError && <FieldError message={priceError} />} */}
        </div>
        <div className={styles.field}>
          <label>
            Select Collection<span>*</span>
          </label>
          {/* {collections && ( */}
            <select
              name="collections"
              value={collection}
              onChange={(e) => setCollection(e.target.value)}
            >
              <option value="select">Select Collection</option>
              <option value="select">Select Collection</option>
              <option value="select">Select Collection</option>
              {/* {collections.map((i) => (
                <option value={i._id} key={i._id}>{i.collectionName}</option>
              ))} */}
            </select>
          {/* )} */}
          {/* {collectionError && <FieldError message={collectionError} />} */}
        </div>
        <div className={styles.field}>
          <label>
            Visibility<span>*</span>
          </label>
          <select
            name="visibility"
            value={visibility}
            onChange={(e) => setVisibility(e.target.value)}
          >
            <option value={false}>Private</option>
            <option value={true}>Public</option>
          </select>
          {/* {visibilityError && <FieldError message={visibilityError} />} */}
        </div>
        <div className={styles.field}>
          <label>Properties</label>
          <input
            type="text"
            placeholder="E.g ‘Background’ ‘Green’"
            value={properties}
            onChange={(e) => setProperties(e.target.value)}
          />
          {/* {propertiesError && <FieldError message={propertiesError} />} */}
        </div>
        <button type="button">{loading ? <Spinner /> : 'Add NFT'}</button>
      </form>
    </div>
  );
};

export default Card;
